module.exports = __webpack_public_path__ + "img/dark.0f5122a9.jpg";